(function() {
    'use strict';

    // Register all routes handled by this module
    angular
    .module('GorillaBoy.Search')
    .config(['$routeProvider', function ($routeProvider) {
        var TEMPLATE_LAYOUT = './assets/partials/app/layout.html';

        // Angular's resolve hashmap values need to be either Promises or a function.
        // This makes it shorter to generate functions that return a given value.
        function makeReturnFunc(returnValue) {
            return function () { return returnValue; };
        }

        function resolveUserInfo () {
            return ['AuthService', function (authService) {
                return authService.getUserInfo();
            }];
        }

        function getUserFavorites() {
            return ['FavoritesService', 'FeatureManagerService', '$q', 'Features', function(FavoritesService, FeatureManagerService, $q, Features) {
                return $q(function(resolve, reject) {
                    FeatureManagerService.getEnabledFeatureMap().then(function() {
                        if (FeatureManagerService.isFeatureEnabled(Features.UI.FAVORITES)) {
                            FavoritesService.getCachedUserFavorites().then(resolve, reject);
                        } else {
                            //Resolve with empty data.
                            resolve({Documents : [], Folders : []});
                        }
                    });
                });
            }];
        }

        function resolveForView (viewName) {
            return {
                View: makeReturnFunc(viewName),
                userInfo: resolveUserInfo(),
                //We should ask for featureMap even though we do not use directly in SearchController. That's because the rest of the app depends on it!
                //For example, the left nav links won't hide/show if we don't resolve for the FeatureManager data
                featureMap: ['FeatureManagerService', function (featureManagerService) {
                    return featureManagerService.getEnabledFeatureMap();
                }],
                Favorites : getUserFavorites()
            };
        }

        $routeProvider
        .when('/search/:queryString', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'SearchController',
            auth: true,
            resolve: resolveForView('SEARCH')
        });
    }]);
}());